import React, { FC, memo, RefObject, useCallback } from "react";

import { Flex, IconButton, Text } from "@/eworkitComponents/components";

export interface IListPaginationProps {
  total?: number;
  pages?: number;
  page?: number;
  size?: number;
  disabled?: boolean;
  onPageChange?: (page: number) => void;
  applicationsPaginationRef?: RefObject<HTMLDivElement>;
}

export const ListPagination: FC<IListPaginationProps> = memo(
  ({ total = 0, page = 0, pages = 0, size = 0, disabled = false, onPageChange, applicationsPaginationRef }) => {
    const isOnFirstPage = page === 0;
    const isOnLastPage = page === pages - 1;
    const firstElement = page * size;
    const lastElement = firstElement + size > total ? total : firstElement + size;

    const handlePageChange = useCallback(
      (p: number) => () => {
        onPageChange?.(p);
      },
      [onPageChange],
    );

    return (
      <Flex ref={applicationsPaginationRef} direction="row" align="center" padding={["sm", false]}>
        <IconButton
          icon="arrow"
          size="xl"
          variant="secondary"
          disabled={disabled || isOnFirstPage}
          onClick={handlePageChange(page - 1)}
        />

        <Flex grow={1} justify="center">
          <Text color="secondary">
            {firstElement + 1} - {lastElement} of {total}
          </Text>
        </Flex>

        <IconButton
          icon="arrow_right"
          size="xl"
          variant="secondary"
          disabled={disabled || isOnLastPage}
          onClick={handlePageChange(page + 1)}
        />
      </Flex>
    );
  },
);
